@if(examName){
<div class="form-for-value">
    <mat-card style="max-width: 650px;">
        <mat-card-header>
            <mat-card-title style="font-size: 1.2rem;">
                Observation Result for {{examName | titlecase}}
            </mat-card-title>
            <mat-card-subtitle class="subtitle-text-color-2">
                Document your assessment of {{examName | titlecase}}.
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="my-18" style="max-width: 650px;">

                <mat-form-field appearance="fill" style="display: block; width: 100%;">


                    <textarea #scsc name="abdominalTenderness" id="abdominalTenderness" matInput [attr.rows]="4"
                        [placeholder]="data.placeholder??'Enter A Value'"></textarea>

                </mat-form-field>
            </div>
        </mat-card-content>
        <mat-card-actions align="end">
            <!--cancel button-->
            <button mat-stroked-button style="width: max-content; margin-right: 20px;
            " (click)="dRef.close(null)">
                <mat-icon>close</mat-icon>
                Cancel
            </button>
            <button mat-flat-button color="primary" (click)="scsc.value ? addAndClose(scsc.value) : addAndClose('')">
                Add To Observations
            </button>
        </mat-card-actions>



    </mat-card>
</div>
}